/* CANFOTO PERFORMANCE P1-R2B
   Makeup/RGB persistent iframe.
   Theme change: CSS/copy switch only, no iframe rebuild, no video restart.
*/
(() => {
  'use strict';

  if(window.__CANFOTO_MAKEUP_P1R2B__)return;
  window.__CANFOTO_MAKEUP_P1R2B__=true;

  const VERSION='CANFOTO-PERFORMANCE-P1-R2B-MAKEUP-PERSISTENT-IFRAME';
  const PAYLOAD_GLOBAL='__CANFOTO_MAKEUP_P1R2B_PAYLOAD__';
  const TARGET_PRODUCT_URL="https://www.canfoto.com/products/gdx-ml-200r-ii-200w-rgb-profesyonel-studyo-ve-urun-cekim-isik-kiti";
  const ALIAS={'cf-editorial':'editorial','cf-magazine':'magazine','cf-nature':'nature','cf-newsroom':'newsroom','cf-retrofuture':'retrofuture','cf-redaxis':'redaxis','cf-chrome':'chrome','cf-cinema':'cinema','cf-hyperpop':'hyperpop'};
  const mq=matchMedia('(max-width:720px)');
  let payloadPromise=null;

  const cleanText=v=>String(v||'').replace(/\s+/g,' ').trim();

  function activeTheme(){
    const raw=cleanText(document.documentElement.dataset.cfTheme);
    if(ALIAS[raw])return ALIAS[raw];

    const fallback=cleanText(
      document.body?.getAttribute('data-cf45-experience') ||
      document.body?.getAttribute('data-cf-experience')
    );

    return ALIAS[fallback]||fallback.replace(/^cf-/,'')||'cinema';
  }

  function enforceTargetCta(sec){
    if(!sec)return null;
    const cta=[...sec.querySelectorAll('a.cf61-makeup-campaign__cta')]
      .find(a=>/GDX\s*ML-200R\s*II/i.test(cleanText(a.textContent)));

    if(!cta)return null;
    if(cta.getAttribute('href')!==TARGET_PRODUCT_URL)cta.setAttribute('href',TARGET_PRODUCT_URL);
    cta.dataset.cf61CanonicalProductUrl='P1-R2B';
    return cta;
  }

  function ensureMounted(){
    const sec=document.querySelector('[data-cf61-makeup-campaign-r2h]');
    if(!sec){
      document.documentElement.dataset.cfHomeMakeupCampaignMount='STATIC_SECTION_MISSING';
      return null;
    }

    enforceTargetCta(sec);
    document.documentElement.dataset.cfHomeMakeupCampaignMount='STATIC_SHOPIFY_SECTION';
    return sec;
  }

  function loadPayload(sec){
    if(window[PAYLOAD_GLOBAL])return Promise.resolve(window[PAYLOAD_GLOBAL]);
    if(payloadPromise)return payloadPromise;

    const url=sec.dataset.cf61PayloadUrl;
    if(!url)return Promise.reject(new Error('PAYLOAD_URL_MISSING'));

    payloadPromise=new Promise((resolve,reject)=>{
      const existing=document.querySelector('script[data-cf61-payload-loader="1"]');

      if(existing){
        if(window[PAYLOAD_GLOBAL]){
          resolve(window[PAYLOAD_GLOBAL]);
          return;
        }
        existing.addEventListener('load',()=>resolve(window[PAYLOAD_GLOBAL]),{once:true});
        existing.addEventListener('error',reject,{once:true});
        return;
      }

      const script=document.createElement('script');
      script.src=url;
      script.async=true;
      script.dataset.cf61PayloadLoader='1';
      script.addEventListener('load',()=>{
        const loaded=window[PAYLOAD_GLOBAL];
        if(loaded)resolve(loaded);
        else reject(new Error('PAYLOAD_GLOBAL_MISSING'));
      },{once:true});
      script.addEventListener('error',reject,{once:true});
      document.head.appendChild(script);
    });

    return payloadPromise;
  }

  function themePayload(payload,theme,mode){
    const rec=payload.themes[theme]||payload.themes.cinema||payload.themes.editorial;
    return {
      key:theme,
      documentTitle:mode==='mobile'?rec.documentTitleMobile:rec.documentTitleDesktop,
      metaTheme:rec.metaTheme,
      benchmark:rec.benchmark,
      bodyStyle:rec.bodyStyle,
      logoThemeClass:rec.logoThemeClass,
      stageMessages:rec.stageMessages,
      heroLine:rec.heroLine,
      css:mode==='mobile'?rec.mobileCss:rec.desktopCss
    };
  }

  function buildDocument(payload,theme,mode){
    const rec=themePayload(payload,theme,mode);
    return payload.templates[mode].replace('__CF61_THEME_CSS__',rec.css);
  }

  function applyThemeWithoutReload(sec,payload){
    const frame=sec.querySelector('[data-cf61-banner-frame-r2h]');
    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(!frame||!box||box.dataset.cf61Loaded!=='1')return false;

    const mode=box.dataset.cf61ActiveSource||(mq.matches?'mobile':'desktop');
    const theme=activeTheme();

    try{
      const api=frame.contentWindow?.__CF61_APPLY_THEME;
      if(typeof api!=='function')return false;

      api(themePayload(payload,theme,mode));

      frame.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveKey=theme+'|'+mode;
      return true;
    }catch(_){
      return false;
    }
  }

  async function loadFrame(sec,forceMode=false){
    const frame=sec.querySelector('[data-cf61-banner-frame-r2h]');
    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(!frame||!box)return;

    const mode=mq.matches?'mobile':'desktop';
    const theme=activeTheme();

    if(!forceMode &&
       box.dataset.cf61Loaded==='1' &&
       box.dataset.cf61ActiveSource===mode){
      const loaded=window[PAYLOAD_GLOBAL];
      if(loaded)applyThemeWithoutReload(sec,loaded);
      return;
    }

    box.dataset.cf61Loading='1';
    delete box.dataset.cf61Error;

    try{
      const payload=await loadPayload(sec);

      const latestMode=mq.matches?'mobile':'desktop';
      if(latestMode!==mode){
        delete box.dataset.cf61Loading;
        loadFrame(sec,true);
        return;
      }

      frame.onload=()=>{
        const livePayload=window[PAYLOAD_GLOBAL];
        if(livePayload)applyThemeWithoutReload(sec,livePayload);

        box.dataset.cf61Loaded='1';
        box.dataset.cf61Ready='1';
        box.dataset.cf61Deferred='0';
        delete box.dataset.cf61Loading;
      };

      frame.srcdoc=buildDocument(payload,theme,mode);
      frame.dataset.cf61ActiveSource=mode;
      frame.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveSource=mode;
      box.dataset.cf61ActiveTheme=theme;
      box.dataset.cf61ActiveKey=theme+'|'+mode;
      box.dataset.cf61OracleVideo=payload.video||'';
    }catch(error){
      box.dataset.cf61Error=String(error?.message||error);
      delete box.dataset.cf61Loading;
    }
  }

  function bind(sec){
    if(sec.dataset.cf61BoundP1R2B==='1')return;
    sec.dataset.cf61BoundP1R2B='1';

    enforceTargetCta(sec);

    const box=sec.querySelector('[data-cf61-frame-r2h]');
    if(box)box.dataset.cf61Deferred='1';

    let queued=0;
    const syncTheme=()=>{
      cancelAnimationFrame(queued);
      queued=requestAnimationFrame(()=>{
        const payload=window[PAYLOAD_GLOBAL];
        if(payload &&
           box?.dataset.cf61Loaded==='1' &&
           box.dataset.cf61ActiveSource===(mq.matches?'mobile':'desktop')){
          applyThemeWithoutReload(sec,payload);
        }
      });
    };

    const breakpoint=()=>{
      if(box?.dataset.cf61Loaded==='1')loadFrame(sec,true);
    };

    if(mq.addEventListener)mq.addEventListener('change',breakpoint);
    else mq.addListener(breakpoint);

    new MutationObserver(syncTheme).observe(
      document.documentElement,
      {attributes:true,attributeFilter:['data-cf-theme']}
    );

    if(document.body){
      new MutationObserver(syncTheme).observe(
        document.body,
        {attributes:true,attributeFilter:['data-cf45-experience','data-cf-experience']}
      );
    }

    new MutationObserver(()=>enforceTargetCta(sec)).observe(
      sec,
      {subtree:true,childList:true,attributes:true,attributeFilter:['href']}
    );

    if(!('IntersectionObserver' in window)){
      loadFrame(sec);
      return;
    }

    const io=new IntersectionObserver(entries=>{
      if(!entries.some(entry=>entry.isIntersecting))return;
      io.disconnect();
      loadFrame(sec);
    },{
      root:null,
      rootMargin:'700px 0px',
      threshold:.01
    });

    io.observe(sec);
  }

  function boot(){
    document.documentElement.dataset.cfHomeMakeupCampaign='P1-R2B';
    const sec=ensureMounted();
    if(sec)bind(sec);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }

  document.addEventListener('shopify:section:load',event=>{
    const sec=event.target?.querySelector?.('[data-cf61-makeup-campaign-r2h]')||ensureMounted();
    if(sec)bind(sec);
  });

  window.debugCanFotoMakeupP1R2B=function(){
    const sec=document.querySelector('[data-cf61-makeup-campaign-r2h]');
    const frame=sec?.querySelector('[data-cf61-banner-frame-r2h]');
    const box=sec?.querySelector('[data-cf61-frame-r2h]');

    let innerTheme=null;
    let video=null;
    try{
      innerTheme=frame?.contentDocument?.documentElement?.dataset.cf61InnerTheme||null;
      video=frame?.contentDocument?.querySelector('video.bg')||null;
    }catch(_){}

    const src=video?.querySelector('source')?.src||video?.currentSrc||'';

    const result={
      sectionPresent:!!sec,
      payloadLoaded:!!window[PAYLOAD_GLOBAL],
      payloadScriptAsync:!!document.querySelector('script[data-cf61-payload-loader="1"]'),
      deferred:box?.dataset.cf61Deferred||null,
      ready:box?.dataset.cf61Ready||null,
      mode:box?.dataset.cf61ActiveSource||null,
      pageTheme:activeTheme(),
      innerTheme,
      iframeReloadKey:box?.dataset.cf61ActiveKey||null,
      videoShopifyCdn:src.startsWith('https://cdn.shopify.com/videos/'),
      videoPreload:video?.preload||null,
      videoCurrentTime:video?Number(video.currentTime.toFixed(2)):null,
      videoPaused:video?.paused??null,
      error:box?.dataset.cf61Error||null
    };

    result.ok=
      result.sectionPresent &&
      (!result.payloadLoaded||result.error===null) &&
      (!result.ready||(
        result.ready==='1' &&
        result.innerTheme===result.pageTheme &&
        result.videoShopifyCdn &&
        result.videoPreload==='metadata'
      ));

    console.table(result);
    return result;
  };
})();
